import { render, staticRenderFns } from "./BusinessDisclaimer.vue?vue&type=template&id=0ec8f658"
import script from "./BusinessDisclaimer.vue?vue&type=script&lang=js"
export * from "./BusinessDisclaimer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports